exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".markdown{display:flex;flex-direction:column;width:100%;height:100%}.markdown .loading{margin-top:12px;text-align:center}.markdown .md-container{height:100%}.markdown .md-container .edit-container{position:relative;height:100%;display:flex}.markdown .md-container button.edit{float:right;margin:10px}.markdown .md-container button.save{position:absolute;top:10px;right:7px}.markdown .md-container textarea{padding:12px;width:100%;flex-grow:1;border:none;resize:none;font-family:monospace;outline:none}.markdown .content{padding:12px}.markdown .content img{max-width:100%}", ""]);

// exports
